import {Action} from '@ngrx/store';
import { CommandStackAction } from '@ispm/shared/bpmn-io/commandstack-action';

export enum UserInitiatedActionsActionTypes {
    ADD_ACTION = '[user initiated actions] add action',
    CLEAR_ACTIONS = '[user initiated actions] clear actions',
    REMOVE_ACTION = '[user initiated actions] remove action'
}

export class AddUnsavedAction implements Action {
  readonly type = UserInitiatedActionsActionTypes.ADD_ACTION;
  constructor(public payload: CommandStackAction) { }
}

export class ClearUnsavedActions implements Action {
  readonly type = UserInitiatedActionsActionTypes.CLEAR_ACTIONS;
  constructor() { }
}

export class RemoveUnsavedAction implements Action {
  readonly type = UserInitiatedActionsActionTypes.REMOVE_ACTION;
  constructor() { }
}

export type UserInitiatedAction = AddUnsavedAction | ClearUnsavedActions | RemoveUnsavedAction;